import { Star } from "phosphor-react";
import React from "react";

const Card = ({ data }) => {
  return (
    <>
      <div className="relative transition-all duration-200 ease-in-out border border-slate-50 shadow-2xl p-4 rounded-3xl bg-white">
        <div className="absolute bottom-0 right-0 w-full">
          <div className="px-4 lg:px-10 py-6 bg-white/50 backdrop-blur-lg z-20 rounded-b-2xl">
            <h1 className="text-xl lg:text-3xl text-slate-900 font-bold mb-4">
              {data.title}
            </h1>
            <div className="flex mb-4 space-x-4 items-center">
              <p className="text-lg lg:text-xl text-slate-600 font-medium">
                {data.genres}
              </p>
              <div className="h-[6px] w-[6px] rounded-full bg-slate-600"></div>
              <p className="text-lg lg:text-xl text-slate-600 font-medium">
                {data.time}
              </p>
            </div>
            <div className="border-t py-4">
              <p className="text-lg text-slate-600 font-normal">
                {data.description}
              </p>
            </div>
            <div>
              <h1 className="text-slate-500 font-medium mb-2">
                INVITE YOUR FRIEND
              </h1>
              <div className="flex w-full bg-white rounded-3xl px-6 py-3 shadow-2xl justify-between space-x-3 items-center">
                <div className="flex space-x-3 items-center">
                  <img
                    src="https://m.media-amazon.com/images/M/MV5BNjM1NTI1MjIwMl5BMl5BanBnXkFtZTgwNzk0NDI0NjE@._V1_UY317_CR11,0,214,317_AL_.jpg"
                    alt=""
                    className="rounded-2xl h-16 w-16 object-cover"
                  />
                  <div>
                    <p className="text-lg text-slate-900 font-medium">
                      Robert Fox
                    </p>
                  </div>
                </div>
                <button className="py-3 px-6 text-white transition-all duration-200 ease-in-out hover:scale-110 rounded-xl bg-slate-900">
                  <span>Invite</span>
                </button>
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <img
          className="rounded-2xl object-cover h-[650px] w-full"
          src={data.poster}
          alt=""
        />
        <div className="flex space-x-3 items-center absolute top-8 right-8 bg-white/50 backdrop-blur-md py-3 px-6 rounded-xl">
          <span className="text-lg lg:text-2xl font-semibold text-slate-700">
            {data.imdb_rating}
          </span>
          <Star className="text-yellow-500" size={24} weight="fill" />
        </div>
      </div>
    </>
  );
};

export default Card;
